/* eslint-disable max-len */
import { WorkflowSnippetFn, ModelLanguage } from '../types';

const pythonSDK: WorkflowSnippetFn = (props) => `
from clarifai.client.workflow import Workflow
import cv2


image_url = "https://s3.amazonaws.com/samples.clarifai.com/featured-models/general-elephants.jpg"
workflow_url =  "https://clarifai.com/${props.userId}/${props.appId}/workflows/${props.workflowId}"
# Creating the workflow
image_segmentation_workflow = Workflow(
    url=workflow_url, pat="${props.pat}"
)
# Getting the predictions
result = image_segmentation_workflow.predict_by_url(
image_url ,
    input_type="image",
)
im_b = result.results[0].outputs[0].data.regions[0].region_info.mask.image.base64
image_np = np.frombuffer(im_b, np.uint8)
img_np = cv2.imdecode(image_np, cv2.IMREAD_COLOR)
# Display the image
plt.axis("off")
plt.imshow(img_np[..., ::-1])
`;

const nodejs_SDK: WorkflowSnippetFn = (props) => `
import { Workflow } from "clarifai-nodejs";
import fs from "fs";


const imageUrl = "https://s3.amazonaws.com/samples.clarifai.com/featured-models/general-elephants.jpg";
const workflowUrl = "https://clarifai.com/${props.userId}/${props.appId}/workflows/${props.workflowId}"

// Creating the workflow
const imageSegmentationWorkflow = new Workflow({
  url: workflowUrl,
  authConfig: {
    pat: "${props.pat}",
  },
});

// Getting the predictions
const prediction = await imageSegmentationWorkflow.predictByUrl(
  imageUrl,
  "image",
);

const imB =
  prediction.resultsList?.[0]?.outputsList?.[0]?.data?.regionsList?.[0]
    ?.regionInfo?.mask?.image?.base64 ?? "";

// Write the output to a file
fs.writeFileSync("image.png", imB, "base64");
`;

export const visualSegmenterSnippetsForWorkflow = {
  [ModelLanguage.PythonSDK]: pythonSDK,
  [ModelLanguage.NodeJS_SDK]: nodejs_SDK,
};
